// extracted by mini-css-extract-plugin
export default {"overlay":"Bx-z","bodyOpen":"Cx-z","content":"Dx-z","header":"Ex-z","close":"Fx-z","closeNoHeading":"Gx-z"};